import * as React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../api/authClientApi';
import { ProtectedPageWrapper } from '../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';

export default function LogoutPage(): JSX.Element{

    const navigate = useNavigate();

    useEffect(() => {
        const getData = async () => {
			await logout();
            navigate('/login');
        };
        getData();
    }, []);
    
    return ( 
        <ProtectedPageWrapper requiredPermissions={['Logout']}>
        </ProtectedPageWrapper>
    );
}